var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongXiaoxi3Xian1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57 14.298c-1.696-1.012-2.82-2.779-2.82-4.79 0-3.14 2.742-5.687 6.125-5.687a6.41 6.41 0 013.689 1.147c-1.142-1.991-3.373-3.343-5.939-3.343C3.897 1.625.875 4.479.875 8a6.12 6.12 0 001.353 3.83l-.492 1.863a.314.314 0 00.35.39l2.496-.371-.047-.043a6.98 6.98 0 002.035.629z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.625 9.5c0 2.692 2.35 4.875 5.25 4.875a5.59 5.59 0 001.958-.35l-.003.002 1.941.29a.244.244 0 00.272-.304l-.316-1.2c.868-.87 1.398-2.034 1.398-3.313 0-2.692-2.35-4.875-5.25-4.875S4.625 6.808 4.625 9.5zm3.607-1.116a.447.447 0 00-.41.27l-.588 1.355a.447.447 0 10.82.355l.588-1.355a.447.447 0 00-.41-.625zm1.564.27a.447.447 0 01.82.355l-.587 1.355a.447.447 0 01-.82-.355l.587-1.356zm2.385-.27a.447.447 0 00-.41.27l-.588 1.355a.447.447 0 10.82.355l.588-1.355a.447.447 0 00-.41-.625z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_xiaoxi3_xian1.7aae1abb.svg";
export { SvgTongyongXiaoxi3Xian1 as ReactComponent };